module.exports = require("./moment.js");


/*****************
 ** WEBPACK FOOTER
 ** moment (bower component)
 ** module id = 377
 ** module chunks = 1
 **/